import { defineComponent as _defineComponent } from 'vue'
import { FunnelsServices } from "@/services";
import { IRateLimit } from "@/services/FunnelService";
import { computed, Ref, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RateLimits',
  setup(__props) {

const DEFAULT_IP_RATE_LIMIT_WINDOW = 60000;
const DEFAULT_IP_RATE_LIMIT_MAX = 10;
const DEFAULT_LOCATION_RATE_LIMIT_WINDOW = 60000;
const DEFAULT_LOCATION_RATE_LIMIT_MAX = 500;

const altId = ref("");
const loading = ref({
  upsert: false,
  get: false,
  delete: false,
});
const upsertAltId = ref("");
const getType = ref<"location" | "company">("company");
const setType = ref<"location" | "company">("company");
const rateLimit = ref<any>(null);
const ipRateLimitConfig = ref({
  window: undefined,
  max: undefined,
});
const locationRateLimitConfig = ref({
  window: undefined,
  max: undefined,
});
const error: Ref<Record<string, string | null>> = ref({
  upsert: null,
  get: null,
  delete: null,
});

const getRateLimit = async () => {
  try {
    loading.value.get = true;
    if (!altId.value) {
      alert("Please enter an Agency ID/Location ID");
      return;
    }
    if (!getType.value) {
      alert("Please select a type (Agency or Location)");
      return;
    }

    const { data } = await FunnelsServices.getRateLimit(altId.value, getType.value);
    rateLimit.value = data.configuration ?? {};
    error.value.get = null;
  } catch (err: any) {
    error.value.get =
      err?.response?.data?.message ?? "An error occurred while deleting the rate limit";
    console.error(error);
  } finally {
    loading.value.get = false;
  }
};

const validateRateLimitConfig = computed(() => {
  return (
    (ipRateLimitConfig.value.window && ipRateLimitConfig.value.max) ||
    (locationRateLimitConfig.value.window && locationRateLimitConfig.value.max)
  );
});

const upsertRateLimit = async () => {
  loading.value.upsert = true;
  try {
    const payload: IRateLimit = {
      altId: upsertAltId.value,
      type: setType.value,
    };
    if (ipRateLimitConfig.value.window && ipRateLimitConfig.value.max) {
      payload.ipRateLimitConfig = {
        window: Number(ipRateLimitConfig.value.window),
        max: Number(ipRateLimitConfig.value.max),
      };
    }
    if (locationRateLimitConfig.value.window && locationRateLimitConfig.value.max) {
      payload.locationRateLimitConfig = {
        window: Number(locationRateLimitConfig.value.window),
        max: Number(locationRateLimitConfig.value.max),
      };
    }

    const { data } = await FunnelsServices.upsertRateLimit(payload);

    // Reset the form
    resetForm();
    error.value.upsert = null;
  } catch (err: any) {
    console.error(error);
    error.value.upsert =
      err?.response?.data?.message ?? "An error occurred while creating/updating the rate limit";
  } finally {
    loading.value.upsert = false;
  }
};

const resetForm = () => {
  upsertAltId.value = "";
  ipRateLimitConfig.value = {
    window: undefined,
    max: undefined,
  };

  locationRateLimitConfig.value = {
    window: undefined,
    max: undefined,
  };
  setType.value = "company";
};

const deleteRateLimit = async () => {
  if (!rateLimit.value?.id) {
    alert("No rate limit to delete");
    return;
  }
  try {
    loading.value.delete = true;
    await FunnelsServices.deleteRateLimit(rateLimit.value?.id, altId.value, getType.value);
    rateLimit.value = null;
    error.value.delete = null;
  } catch (err: any) {
    error.value.delete =
      err?.response?.data?.message ?? "An error occurred while deleting the rate limit";
    console.error(error);
  } finally {
    loading.value.delete = false;
  }
};

return { __sfc: true,DEFAULT_IP_RATE_LIMIT_WINDOW, DEFAULT_IP_RATE_LIMIT_MAX, DEFAULT_LOCATION_RATE_LIMIT_WINDOW, DEFAULT_LOCATION_RATE_LIMIT_MAX, altId, loading, upsertAltId, getType, setType, rateLimit, ipRateLimitConfig, locationRateLimitConfig, error, getRateLimit, validateRateLimitConfig, upsertRateLimit, resetForm, deleteRateLimit }
}

})